var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{class:{ whihe_bg: _vm.whiheBg },attrs:{"height":"auto","id":"home_header"}},[_c('root-header',{attrs:{"whihe":_vm.whiheBg}})],1),_c('router-view',{key:_vm.$route.fullPath}),_c('root-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }